module.exports = __webpack_public_path__ + "img/Icon-IN.b3b5a3ae.png";